import React from 'react';
import { MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBFooter,  MDBRow, MDBTable } from 'mdbreact';
import { Link as RouterLink } from 'react-router-dom';

export class ConfirmPayment extends React.Component {
    constructor(props) {
        super(props)
    
        this.state = {
             confirm: false
        }
    }

    paymentConfirm = () => {
        this.setState({confirm: !this.state.confirm})
    }
    
    render() {
        return (
            <>
                <h4><b>Confirm Payment</b></h4>
                <div className="mt-4">
                    <MDBCard>
                        <MDBCardBody>
                            <MDBCardTitle>Basic Information</MDBCardTitle>
                            <hr/>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Country of Residence: </th><td>India</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling To: </th><td>United Arab Emirates</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Type: </th><td>Express | Single Entry</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Duration: </th><td>14 Days</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Nationality: </th><td>Indian</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Applicants: </th><td>02</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="4">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling Dates: </th><td>21 May 2021 To 07 June 2021</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>  
                </div>
                <div className="mt-4">
                    <MDBCard>
                        <MDBCardBody>
                            <MDBCardTitle>Applicants</MDBCardTitle>
                            <hr/>
                            <ul style={{listStyleType:'none', padding:0, margin:0}}>
                                <li>AJAY GANESH MAMGAIN</li>
                                <hr/>
                                <li>AISHWARYA AJAY VELUM</li>
                            </ul>
                        </MDBCardBody>
                    </MDBCard>
                </div>
                <div className="mt-4">
                    <MDBCard>
                        <MDBCardBody>
                            <MDBCardTitle>Payment Details</MDBCardTitle>
                            <hr/>
                            {/* <MDBTable borderless>
                                <tr>
                                    <td>Total Cost</td><td>INR 28,256</td>
                                </tr>
                                <tr>
                                    <td>Payment Status</td><td><MDBBadge color="warning" >Pending</MDBBadge></td>
                                </tr>
                                <tr>
                                    <td>Confirm Payment</td><td><input style={{marginLeft:20}} type="checkbox" id="confirmPayment" /> Yes</td>
                                </tr>
                            </MDBTable> */}
                            <MDBRow>
                                <MDBCol size="6" lg="2">
                                    <p>Total Cost</p>
                                    <p>Payment Status</p>
                                    <p>Confirm Payment</p>
                                </MDBCol>
                                <MDBCol size="6" lg="3s">
                                    <p>INR 28,256</p>
                                    <MDBBadge color="warning" >Pending</MDBBadge><br/>
                                    <div className="mt-3">
                                        <input type="checkbox" onChange={this.paymentConfirm} id="confirmPayment" /> Yes 
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div>
                <MDBRow>
                <MDBFooter style={{background: "#fff" ,  position: "fixed", bottom: "0px" ,width: "100%" , zIndex : "1" ,   left: "0" , right: "0" , borderTop: "1px solid #ccc" , boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)"}} color="white" className="pb-1 pt-1 text-right">

                        {/* <MDBRow>
                        <MDBCol size="12" sm="6" md="6" lg="8" />
                        <MDBCol size="12" sm="6" md="6" lg="4">
                        <RouterLink to="/new-visa/organize"><MDBBtn id="reviewBtn" style={{color:'white',backgroundColor:'#673784',width:'40%', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Organize Application</MDBBtn></RouterLink>
                        </MDBCol>
                        </MDBRow> */}
                        <MDBContainer>
                            <div className="text-right">
                            <RouterLink to="/track-application"><MDBBtn id="backBtn" style={{color:'white',backgroundColor:'black', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Back</MDBBtn></RouterLink>
                            {this.state.confirm &&
                                <RouterLink to="/track-application"><MDBBtn id="confirmBtn" style={{color:'white',backgroundColor:'#673784', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Confirm</MDBBtn></RouterLink>
                            }
                            </div>
                        </MDBContainer>
                    </MDBFooter>
                </MDBRow>
            </>
        )
    }
}

export default ConfirmPayment;
